module.exports = __webpack_public_path__ + "085138df7d86bc3a7f8ad5baeaf1e9f4.png";